export default __webpack_public_path__ + "static/media/onboarding-graphics-small-business-operator.d7ff9bb2.png";